<template>
	<div data-tour-scope="cart-end">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ $vuetify.lang.t('$vuetify.front.ecommerce.cartend') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi prodotto" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="cartend-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="(item.item && item.item.trans && item.item.trans.name) || 'Prodotto'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun elemento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>

										<td class="text-left">{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										<td class="text-left">{{ item?.item?.trans?.name }}</td>
										<td class="text-left">{{ item?.item?.variants?.sku }}</td>
										<td class="text-left">
											<div v-for="(el, i) of item?.item?.variants?.variants" :key="i">
												<b>{{ el.name.trans }}:</b> {{ el.value.trans }}
											</div>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Il prodotto esce dalla vetrina di fine carrello: resta a catalogo e in vendita.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createCartEndTourSteps, stopCartEndTour } from './cart-end-tour';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'CartEnd',
	// pagina, righe e ordinamento stanno nell'URL: refresh e ritorno dalla pagina di aggiunta ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createCartEndTourSteps(), { onStop: stopCartEndTour }) };
	},
	components: {
		TourOverlay,
		KeyValueCard,
	},
	data() {
		return {
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: { sortBy: ['created_at'], sortDesc: [true], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			total: 0,
			headers: [
				// colonna del menu a tre puntini: non si ordina
				{ text: '', value: '', sortable: false },
				{ text: 'Created', value: 'created_at' },
				{ text: 'Prodotto', value: 'trans.name' },
				{ text: 'Sku', value: 'variants.sku' },
				{ text: 'Variante', value: 'typology', sortable: false },
			],
			dialogconfirm: false,
			daEliminare: null,
		};
	},
	created() {
		this.listLoad();
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getItems: 'cartend/getItems',
		}),
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchItems: 'cartend/asyncFetchData',
			destroyData: 'cartend/destroyData',
			delete: 'cartend/deleteItem',
		}),
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			const v = (item.item && item.item.variants) || {};
			const variante = (v.variants || []).map(el => `${(el.name && el.name.trans) || ''}: ${(el.value && el.value.trans) || ''}`).join(', ');
			return [
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Sku', value: v.sku },
				{ label: 'Variante', value: variante },
			];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 5000, text };
		},
		// aggiungere un prodotto e' una pagina: la lista resta nel suo URL e ci si torna uguale
		createItem() {
			this.$router.push('/ecommerce/cartend/new');
		},
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.daEliminare) return;
			this.setPreload(true);
			this.delete(this.daEliminare)
				.then(() => this.getDataFromApi())
				.then(() => this.notifica('success', 'Operazione effettuata con successo'))
				.catch(error => console.log(error))
				.finally(() => {
					this.daEliminare = null;
					this.setPreload(false);
				});
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.cartend-cards,
.cartend-cards tr {
	display: block;
	width: 100%;
}
.cartend-cards tr,
.cartend-cards tr:hover {
	background: transparent !important;
}
.cartend-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.cartend-cards tr:first-child td {
	padding-top: 12px !important;
}
.cartend-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.cartend-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
